import { doc, setDoc, getDoc, Timestamp, type DocumentSnapshot } from 'firebase/firestore';

import {
  BROKEN_PATIENT_REPORT_ACTIONS,
  type BrokenPatientReportAction,
  type DiagnosticsDoc,
} from '@shared/utils/diagnostics.types.js';

import { db } from '../firebase-config';

export const reportBrokenPatientOnce = async (
  userId: string,
  action: BrokenPatientReportAction = BROKEN_PATIENT_REPORT_ACTIONS.BROKEN_PATIENT_DATA_DETECTED,
) => {
  try {
    const brokenRef = doc(db, 'diagnostics', userId);

    const snap = (await getDoc(brokenRef)) as DocumentSnapshot<DiagnosticsDoc>;

    const brokenPatientReport = snap.data()?.brokenPatientReport;

    // Already reported
    if (Object.keys(brokenPatientReport || {}).length > 0) {
      if (import.meta.env.DEV) {
        console.log('Exiting - already reported.');
      }

      return;
    }

    const date = Timestamp.now();

    const payload = {
      action,
      createdAt: date,
      status: 'STARTED',
    };

    await setDoc(brokenRef, { userId, brokenPatientReport: payload }, { merge: true });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Error reporting broken patient data:', error);
    }
  }
};
